export default {
  name: 'CONTACT_FORM_NAME',
  email: 'CONTACT_FORM_EMAIL',
  theme: 'CONTACT_FORM_THEME',
  message: 'CONTACT_FORM_MESSAGE',
  accept: 'CONTACT_FORM_ACCEPT'
};
